import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { Col, Row } from 'react-grid-system';
import { Helmet } from 'react-helmet';
import { useForm, router } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FEAT_COMMUNICATION_RESET_BUTTON } from '../../../config/feature';
import H1 from '../../atoms/title/H1';
import Panel from '../../atoms/Panel';
import Layout from '../../templates/Layout';
import SideBar from '../../organisms/dossier/SideBar';
import Tabs from '../../organisms/dossier/Tabs';
import Message from '../../organisms/message/Message';
import Buttons from '../../molecules/message/Buttons';
import Textarea from '../../atoms/Textarea';
import { color } from '../../templates/Ui';
import Notice, { TYPES } from '../../molecules/Notice';
const StyledTextarea = styled(Textarea) `
    border: 1px solid ${color.border.base};
    border-radius: 6px;
    resize: none;
    min-height: 170px;
    margin-bottom: 20px;

    &:focus {
        border: 1px solid ${color.border.base};
    }

    &::-webkit-input-placeholder {
        font-style: italic;
    }
    &:-moz-placeholder {
        font-style: italic;
    }
    &::-moz-placeholder {
        font-style: italic;
    }
    &:-ms-input-placeholder {
        font-style: italic;
    }
`;
const StyledError = styled.div `
    background: #ffeaea;
    color: #b71c1c;
    border: 1px solid #f44336;
    border-radius: 4px;
    padding: 12px 16px;
    margin-bottom: 16px;
    font-size: 1rem;
    font-weight: 500;
`;
const Communication = ({ dossier, dossierNumber, note, }) => {
    const { t } = useTranslation();
    const fileUploaderRef = useRef(null);
    const { post, data, setData, errors, reset, processing } = useForm({
        message: null,
        dossier_files: [],
    });
    const handleReset = () => {
        reset();
        fileUploaderRef.current?.reset();
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        post(`/dossier/${dossierNumber}/communicatie`, {
            preserveScroll: true,
            onSuccess: () => {
                handleReset();
                router.reload({ only: ['notes'] });
            },
        });
    };
    const handleChange = (e) => {
        let data;
        if (e.currentTarget.type === 'dossier_files') {
            data = e.currentTarget.files;
        }
        else {
            data = e.currentTarget.value;
        }
        // @ts-ignore
        setData(e.currentTarget.name, data);
    };
    return (_jsxs(Layout, { dossierNumber: dossierNumber, "data-testid": "dossier-communication", children: [_jsx(Helmet, { children: _jsxs("title", { children: ["Communicatie - ", t('dossier.title')] }) }), _jsxs(H1, { "data-testid": "title", children: [t('dossier.title'), " ", dossierNumber] }), _jsxs(Row, { children: [_jsx(Col, { sm: 9, children: _jsxs(Panel, { children: [_jsx(Tabs, { dossier: dossier }), note.messages &&
                                    note.messages.length > 0 &&
                                    note.messages.map(noteMessage => (_jsx(Message, { name: noteMessage.user_name +
                                            (noteMessage.is_deleted
                                                ? ' [verwijderd]'
                                                : ''), role: noteMessage.is_admin_user
                                            ? t('communication.contractor_employee')
                                            : t('communication.portal_user'), text: noteMessage.body, initials: noteMessage.user_initials, date: noteMessage.date, id: noteMessage.id, variant: noteMessage.is_admin_user
                                            ? 'contractor'
                                            : undefined, attachments: noteMessage.files }, `note-${noteMessage.id}`))), dossier.closed_at && (_jsx(Notice, { type: TYPES.WARNING, title: t('communication.closed_notice.title'), children: t('communication.closed_notice.message') })), _jsxs("form", { onSubmit: handleSubmit, children: [Object.keys(errors).length > 0 && (_jsx(StyledError, { role: "alert", "data-testid": "form-error", children: Object.values(errors).map((error, idx) => (_jsx("div", { children: error }, idx))) })), _jsx(StyledTextarea, { bordered: true, placeholder: "Typ een bericht..", name: "message", disabled: processing, onChange: handleChange, value: data.message || '' }), errors.message && _jsx("div", { children: errors.message }), _jsx(Buttons, { ref: fileUploaderRef, data: data, setData: setData, loading: processing }), FEAT_COMMUNICATION_RESET_BUTTON.isEnabled && (_jsx("button", { type: "button", onClick: handleReset, children: "reset" }))] })] }) }), _jsx(Col, { sm: 3, children: _jsx(SideBar, { dossier: dossier }) })] })] }));
};
export default Communication;
